module.exports = __webpack_public_path__ + "static/media/NC.7e044e2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NC.svg
// module id = 2223
// module chunks = 7